import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFilePdf,
  faDownload,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';


const ContainerMiembrosBHC = styled.div`
  width: calc(100% - 40px);
  max-width: 1370px;
  margin: 50px auto 40px;
  padding: 40px 45px;
  text-align: center;
  background: #182329ef;
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.25);
  border: 1px solid #3c484d;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: calc(100% - 30px);
    margin: 40px auto 30px;
    padding: 30px 20px;
  }

  @media (max-width: 500px) {
    padding: 25px 15px;
  }
`;


const Titulo = styled.h2`
  font-family: 'GarnetLight';
  font-size: 30px;
  color: #a0f000;
  text-align: center;
  margin: 0 0 10px;
  padding: 0;

  @media (max-width: 768px) {
    font-size: 25px;
  }

  @media (max-width: 500px) {
    font-size: 21px;
  }
`;

const Subtitulo = styled.p`
  font-family: 'Kobern';
  color: #d1d6d8;
  font-size: 15px;
  margin: 0 auto 35px;
  line-height: 1.6;
  max-width: 800px;

  @media (max-width: 600px) {
    font-size: 13px;
  }
`;

const Documentos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
    margin: 0 auto;
`;

const Documento = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;

  width: 100%;
  box-sizing: border-box;

  padding: 20px 22px;

  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(160, 240, 0, 0.18);
  border-radius: 8px;

  text-align: left;

  transition: all 0.25s ease;

  &:hover {
    border-color: rgba(160, 240, 0, 0.5);
    background: rgba(160, 240, 0, 0.06);
    transform: translateY(-2px);
  }

  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
    text-align: center;
  }
`;

const DocumentoInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  min-width: 0;
  flex: 1;

  @media (max-width: 700px) {
    justify-content: center;
  }
`;

const PdfIcon = styled.div`
  width: 48px;
  height: 48px;
  min-width: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(160, 240, 0, 0.12);
  color: #a0f000;

  border-radius: 7px;

  font-size: 23px;
`;

const DocumentoTexto = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
`;

const DocumentoTitulo = styled.h3`
  margin: 0;

  color: #ffffff;

  font-family: 'Kobern';
  font-size: 16px;
  line-height: 1.4;

  @media (max-width: 500px) {
    font-size: 15px;
  }
`;

const DocumentoDescripcion = styled.span`
  color: #9ca6aa;

  font-family: 'Kobern';
  font-size: 13px;
  line-height: 1.4;

  @media (max-width: 500px) {
    font-size: 12px;
  }
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  gap: 9px;

  flex-shrink: 0;

  padding: 12px 22px;

  background: #a0f000;
  color: #182329;

  font-family: 'Kobern';
  font-size: 13px;
  font-weight: bold;

  text-decoration: none;
  text-transform: uppercase;

  border-radius: 5px;

  cursor: pointer;

  transition: all 0.2s ease;

  white-space: nowrap;

  &:hover {
    background: #b8ff00;

    transform: translateY(-1px);

    box-shadow: 0 4px 12px rgba(160, 240, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 700px) {
    width: 100%;
    box-sizing: border-box;
  }
`;

const ServiciosAcompanamientos = () => {

  const documentos = [
    {
      titulo: 'Comunicado General Proyecto Miembros BHC',
      descripcion:
        'Documento informativo del proyecto de miembros BHC.',
      path: '/PDF/COMUNICADO GENERAL PROYECTO MIEMBROS BHC.pdf',
      name: 'COMUNICADO GENERAL PROYECTO MIEMBROS BHC.pdf',
    },
    {
      titulo: 'FAQs Miembro BHC 26-27',
      descripcion:
        'Preguntas frecuentes para los miembros BHC 2026-2027.',
      path: '/PDF/FAQS_MIEMBROS BHC 26_27.pdf',
      name: 'FAQS_MIEMBROS BHC 26_27.pdf',
    },
  ];

  return (
    <ContainerMiembrosBHC>

      <Titulo>
        DOCUMENTACIÓN PROGRAMA MIEMBRO BHC 26-27
      </Titulo>

      <Subtitulo>
        Consulta y descarga la documentación oficial relacionada
        con el proyecto de miembros BHC.
      </Subtitulo>

      <Documentos>

        {/* DOCUMENTOS PDF */}
        {documentos.map((documento) => (

          <Documento key={documento.path}>

            <DocumentoInfo>

              <PdfIcon>
                <FontAwesomeIcon icon={faFilePdf} />
              </PdfIcon>

              <DocumentoTexto>

                <DocumentoTitulo>
                  {documento.titulo}
                </DocumentoTitulo>

                <DocumentoDescripcion>
                  {documento.descripcion}
                </DocumentoDescripcion>

              </DocumentoTexto>

            </DocumentoInfo>

            <DownloadButton
              href={documento.path}
              download={documento.name}
            >
              <FontAwesomeIcon icon={faDownload} />
              Descargar PDF
            </DownloadButton>

          </Documento>

        ))}

        {/* FORMULARIO DE ALTA */}
        <Documento>

          <DocumentoInfo>

            <PdfIcon>
              <FontAwesomeIcon icon={faClipboardList} />
            </PdfIcon>

            <DocumentoTexto>

              <DocumentoTitulo>
                Formulario de alta
              </DocumentoTitulo>

              <DocumentoDescripcion>
                Completa el formulario para darte de alta como miembro BHC.
              </DocumentoDescripcion>

            </DocumentoTexto>

          </DocumentoInfo>

          <DownloadButton
            href="https://docs.google.com/forms/d/e/1FAIpQLSeGq1cAkvwtpL7Vtqwiu6cDDcbnVEqs7A62bn5JJAFyoL8-Fg/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faClipboardList} />
            Acceder al formulario
          </DownloadButton>

        </Documento>

      </Documentos>

    </ContainerMiembrosBHC>
  );
};

export default ServiciosAcompanamientos;